<!-- @format -->

<ng-container *transloco="let t">
  <div class="sis-mb-xs">
    @if (!selectedModuleAttainment && plan?.primary && !!degreeProgrammeAttainmentWorkflow) {
      <sis-contextual-notification [variant]="'light'">
        {{ t("MODULE_INFO.GRADUATION.GRADUATION_REQUESTED", { degreeProgrammeName: module.name | localizedString }) }}.
        <a
          id="navigate-to-dpa-application-graduation-section"
          [uiSref]="'student.logged-in.profile.applications.degree-programme-attainment-workflow'"
          [uiParams]="{ applicationId: degreeProgrammeAttainmentWorkflow.id }"
          (click)="closeModal.emit()">
          {{ t("MODULE_INFO.GRADUATION.NAVIGATE_TO_DPA_APPLICATION") }}
        </a>
      </sis-contextual-notification>
    }
  </div>
  @if (!selectedModuleAttainment) {
    <sis-graduation-instructions [organisationId]="organisationId"> </sis-graduation-instructions>
    <p class="guidance">{{ t("MODULE_INFO.GRADUATION.GUIDANCE") }}</p>
    @if (canApplyForGraduation && !degreeProgrammeAttainmentWorkflow) {
      <sis-button
        [size]="'lg'"
        [variant]="'primary'"
        [id]="'navigate-to-graduation-wizard'"
        (clicked)="openGraduationWizard()"
        [type]="'button'">
        {{ t("MODULE_INFO.GRADUATION.NAVIGATE_TO_APPLICATION_CREATION") }}
      </sis-button>
    }
  }
</ng-container>
